import React from 'react';
import { Outlet } from 'react-router-dom';

const NationalStateRouter: React.FC = () => {
  return <Outlet />;
};

export default NationalStateRouter;
